var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isBusy,
          expression: "isBusy",
        },
      ],
      staticClass: "media-list d-flex media-list__thumbnails",
    },
    _vm._l(_vm.getMediaList, function (item) {
      return _c(
        "div",
        { staticClass: "media__item text-center" },
        [
          _c(_vm.getMediaComponent(item), {
            key: item.id,
            tag: "component",
            attrs: { item: item },
            on: { "open-media-dialog": _vm.openDialog },
          }),
          _vm._v(" "),
          _vm.canToggleHide(item) && _vm.isInbound
            ? _c("a", {
                staticClass: "media__item-hide",
                domProps: { textContent: _vm._s(_vm.getButtonText(item)) },
                on: {
                  click: function ($event) {
                    return _vm.toggleHide(item)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }